import React, { useState } from 'react';
import { TextInput } from '../TextInput/TextInput';
import { IconView, IconSuppress, theme, useLocalizationContext, useThemeContext, } from '@contrast-security-inc/design-system-foundations';
import { cx, css } from '@emotion/css';
import * as messages from './translations';
const hideRevealButtonStyles = css `
  background-color: unset;
  border: 1px solid ${theme.color.transparent};
  padding: 0.5rem;
  display: flex;
  margin-right: 0.5rem;
  cursor: pointer;

  &:focus-visible {
    border-radius: 6px;
    border-color: ${theme.color.turquoise70};
    outline: unset;
  }
`;
const passwordInputStyles = css `
  input {
    padding-right: 0px /* let the button handle padding */
  }
`;
const iconColor = (selectedTheme) => (selectedTheme === 'dark' ? 'neutral20' : 'neutral100');
export const PasswordInput = React.forwardRef(({ className, value, isDisabled, showCount = false, isNew = false, units, localeText, testId, ...rest }, ref) => {
    const [isRevealed, setIsRevealed] = useState(false);
    const { selectedTheme } = useThemeContext();
    const { formatMessage } = useLocalizationContext();
    if (showCount && units) {
        console.warn('Since showCount is true, the units will not be shown.');
    }
    const characterCount = value?.length || 0;
    const characterCountText = localeText?.characters
        ? `${characterCount} ${localeText?.characters}`
        : formatMessage(messages, 'characters', { count: characterCount });
    const iconComponent = isRevealed ? (React.createElement(IconSuppress, { size: "sm", color: iconColor(selectedTheme) })) : (React.createElement(IconView, { size: "sm", color: iconColor(selectedTheme) }));
    return (React.createElement(TextInput, { ...rest, className: cx(className, passwordInputStyles, 'ds-password-input'), ref: ref, testId: testId, isDisabled: isDisabled, type: isRevealed ? 'text' : 'password', autoComplete: isNew ? 'new-password' : 'current-password', value: value, units: showCount && !isDisabled ? characterCountText : units, endAdornment: !isDisabled && value ? (React.createElement("button", { "aria-label": isRevealed ? formatMessage(messages, 'hidePassword') : formatMessage(messages, 'showPassword'), className: hideRevealButtonStyles, onClick: () => setIsRevealed((revealed) => !revealed), type: "button" }, iconComponent)) : undefined }));
});
PasswordInput.displayName = 'PasswordInput';
